import React from 'react';
import { FormattedMessage } from 'react-intl';

import Form from 'react-bootstrap/Form';

/**
 * Checkbox components.
 *
 * @param {Object} props configs of checkbox
 */
const checkbox = (props) => {
  const { label, required, error, tip, valid, changed } = props;

  let additionalInfo = <Form.Text className="empty-field-info">&nbsp;</Form.Text>;
  if ((valid && tip) || (!error && tip)) {
    additionalInfo = (
      <Form.Text>
        <FormattedMessage id={`form.field.${label}.tip`} />
      </Form.Text>
    );
  }
  if (!valid && error) {
    additionalInfo = (
      <Form.Text className="error-message-small text-danger">
        <FormattedMessage id={`form.field.${label}.error`} />
      </Form.Text>
    );
  }

  return (
    <Form.Group controlId={label}>
      <Form.Check className={valid ? null : 'is-invalid'} type="checkbox">
        <Form.Check.Input type="checkbox" required={required} value="true" onChange={changed} />
        <Form.Check.Label className={required ? 'field-required' : null}>
          <FormattedMessage id={`form.field.${label}.label`} />
        </Form.Check.Label>
        {additionalInfo}
      </Form.Check>
    </Form.Group>
  );
};

export default checkbox;
